<template>
  <path
    d="M21.41 11.5802L12.41 2.58018C12.05 2.22018 11.55 2.00018 11 2.00018H4C2.9 2.00018 2 2.90018 2 4.00018V11.0002C2 11.5502 2.22 12.0502 2.59 12.4202L11.59 21.4202C11.95 21.7802 12.45 22.0002 13 22.0002C13.55 22.0002 14.05 21.7802 14.41 21.4102L21.41 14.4102C21.78 14.0502 22 13.5502 22 13.0002C22 12.4502 21.77 11.9402 21.41 11.5802ZM5.5 7.00018C4.67 7.00018 4 6.33018 4 5.50018C4 4.67018 4.67 4.00018 5.5 4.00018C6.33 4.00018 7 4.67018 7 5.50018C7 6.33018 6.33 7.00018 5.5 7.00018Z"
  />
</template>
